[
  {
    "id": "muse-spark-1-2-launch",
    "entityId": "muse-spark-1-2",
    "title": "Meta introduced Muse Spark 1.2 and Muse Code",
    "summary": "Meta published Muse Spark 1.2 as a coding-focused update and described co-training the model with a persistent, event-logged coding harness. Performance statements remain vendor-reported until independent results arrive.",
    "effectiveAt": "2026-08-05T16:00:00.000Z",
    "verifiedAt": "2026-08-08T03:30:00.000Z",
    "evidenceClass": "official",
    "status": "current",
    "topics": ["models", "agents", "coding", "harnesses"],
    "sources": [
      {
        "title": "Introducing Muse Code and Muse Spark 1.2",
        "publisher": "Meta AI Research",
        "url": "https://research.meta.ai/blog/introducing-muse-code-and-muse-spark-1-2",
        "sourceKind": "primary",
        "publishedAt": "2026-08-05T16:00:00.000Z",
        "retrievedAt": "2026-08-08T03:30:00.000Z"
      }
    ]
  },
  {
    "id": "qwen3-8-max-announcement",
    "entityId": "qwen3-8-max",
    "title": "Alibaba announced Qwen3.8-Max",
    "summary": "Alibaba announced Qwen3.8-Max as a 2.4-trillion-parameter multimodal model with 95 billion active parameters and a one-million-token context window. This ledger has not yet verified the promised open-weight publication.",
    "effectiveAt": "2026-08-03T12:00:00.000Z",
    "verifiedAt": "2026-08-08T03:30:00.000Z",
    "evidenceClass": "official",
    "status": "current",
    "topics": ["models", "open-weights", "multimodal", "agents"],
    "sources": [
      {
        "title": "Qwen3.8",
        "publisher": "Alibaba Qwen",
        "url": "https://qwen.ai/blog?id=qwen3.8",
        "sourceKind": "primary",
        "publishedAt": "2026-08-03T12:00:00.000Z",
        "retrievedAt": "2026-08-08T03:30:00.000Z"
      }
    ]
  },
  {
    "id": "openai-ten-math-advances-report",
    "entityId": "openai-ten-math-advances",
    "title": "OpenAI reported ten advances in mathematics and theoretical computer science",
    "summary": "OpenAI released manuscripts, reasoning walkthroughs, and Lean formalizations for ten selected results generated with an unreleased internal model. The report is primary evidence of the work and does not replace independent mathematical review.",
    "effectiveAt": "2026-08-01T15:00:00.000Z",
    "verifiedAt": "2026-08-08T03:30:00.000Z",
    "evidenceClass": "official",
    "status": "current",
    "topics": ["research", "mathematics", "formal-verification"],
    "sources": [
      {
        "title": "Ten advances in mathematics and theoretical computer science",
        "publisher": "OpenAI",
        "url": "https://openai.com/index/ten-advances-in-mathematics/",
        "sourceKind": "primary",
        "publishedAt": "2026-08-01T15:00:00.000Z",
        "retrievedAt": "2026-08-08T03:30:00.000Z"
      }
    ]
  },
  {
    "id": "claude-opus-5-launch",
    "entityId": "claude-opus-5",
    "title": "Anthropic released Claude Opus 5",
    "summary": "Anthropic released Opus 5 with a one-million-token context window and API pricing of $5 per million input tokens and $25 per million output tokens. Benchmark and customer-performance assertions in the launch remain vendor-reported unless separately corroborated.",
    "effectiveAt": "2026-07-24T15:00:00.000Z",
    "verifiedAt": "2026-08-08T03:30:00.000Z",
    "evidenceClass": "official",
    "status": "current",
    "topics": ["models", "agents", "coding", "pricing"],
    "sources": [
      {
        "title": "Introducing Claude Opus 5",
        "publisher": "Anthropic",
        "url": "https://www.anthropic.com/news/claude-opus-5",
        "sourceKind": "primary",
        "publishedAt": "2026-07-24T15:00:00.000Z",
        "retrievedAt": "2026-08-08T03:30:00.000Z"
      }
    ]
  },
  {
    "id": "gpt-5-6-sol-launch",
    "entityId": "gpt-5-6-sol",
    "title": "OpenAI released GPT-5.6 Sol",
    "summary": "OpenAI released the GPT-5.6 family for general availability, including the Sol flagship with a 1.05-million-token context window and multi-agent support in beta through the Responses API.",
    "effectiveAt": "2026-07-09T15:00:00.000Z",
    "verifiedAt": "2026-08-08T03:30:00.000Z",
    "evidenceClass": "official",
    "status": "current",
    "topics": ["models", "agents", "coding", "multi-agent"],
    "sources": [
      {
        "title": "GPT-5.6: Frontier intelligence that scales with your ambition",
        "publisher": "OpenAI",
        "url": "https://openai.com/index/gpt-5-6/",
        "sourceKind": "primary",
        "publishedAt": "2026-07-09T15:00:00.000Z",
        "retrievedAt": "2026-08-08T03:30:00.000Z"
      }
    ]
  }
]

